import { render } from "./UsersIcon.vue?vue&type=template&id=cd925614&scoped=true"
const script = {}

import "./UsersIcon.vue?vue&type=style&index=0&id=cd925614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd925614"]])

export default __exports__